export default __webpack_public_path__ + "static/media/details08.f4d7ef2f.svg";